export const msalConfig = {
  auth: {
    clientId: "9ab9b377-50c1-4b46-9252-e88e8ef4db79", // Replace with your Entra ID Application (client) ID
    authority: "https://login.microsoftonline.com/38e8ff4e-d74a-4d99-85f5-f75f7742d84d", // Use tenant ID only, no /v2.0
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["api://f3b909f1-6ec1-480b-95cd-9fda68b7992f/user_impersonation"],
};
